import {defineStore} from 'pinia';
import {ModuleAccountingObjectCategory} from '../moduleConst';
import accountObjectAPI from '@/apis/di/accountingObjectCategoryAPI';
import {BaseDictionaryStore} from '../baseDictionaryStore';
const accountObjectStore = new BaseDictionaryStore(accountObjectAPI);
export const useAccountingObjectCategoryStore = defineStore(ModuleAccountingObjectCategory, {
  state: () => ({
    ...accountObjectStore.state,
    _config: {
      key: 'accounting_object_category_id',
      name: 'accounting_object_category_name',
      table: 'di_accounting_object_category',
      moduleName: 'Loại đối tượng',
      quickFollow: 'active',
      defaultSort: 'accounting_object_category_name',
    },
    moduleName: 'accountingObjectCategory',
  }),
  actions: {...accountObjectStore.action},
  getters: {
    ...accountObjectStore.getters,
  },
});
